import React from 'react';
import PropTypes from 'prop-types';

import '../styles/Topbar.css';

import {ReactComponent as RawIcon} from '../icons/raw-icon.svg';
import {ReactComponent as CFast} from '../icons/c-fast-icon.svg';
import {ReactComponent as MP4Icon} from '../icons/mp4-icon.svg';
import {ReactComponent as CDCard} from '../icons/sd-card-a-icon.svg';
import {ReactComponent as XfIcon} from '../icons/xf-avc-icon.svg';

const icons1 = {
  raw: <CFast className="Icon-topbar c-fast" />,
  mp4: <CDCard className="Icon-topbar" />,
  xf: <CDCard className="Icon-topbar" />,
}

const icons2 = {
  raw: <RawIcon className="Icon-topbar" />,
  mp4: <MP4Icon className="Icon-topbar" />,
  xf: <XfIcon className="Icon-topbar" />,
}

const minutes = {
  raw_4096x2160: '16min',
  mp4_3840x2160: '113min',
  mp4_1920x1080: '485min',
  xf_3840x2160: '106min',
  xf_1920x1080: ' 377min',
}

const Topbar = ({ visibility, frameRateIcon, recFormat, resolution }) => {
  let min = recFormat + '_' + resolution;
  const className = visibility;
  return (
    <ul className={`Topbar ${className}`}>
      <li className="Topbar-item">
        {icons1[recFormat]}
      </li>
      <li className="Topbar-item">{minutes[min]}</li>
      <li className="Topbar-item">
        {icons2[recFormat]}
      </li>
      <li className="Topbar-item">STBY</li>
      <li className="Topbar-item">{frameRateIcon}</li>
      <li className="Topbar-item">00:00:00.00</li>
      <li className="Topbar-item">P</li>
    </ul>
  );
};

Topbar.propTypes= {
  visibility: PropTypes.string.isRequired,
  frameRateIcon: PropTypes.string.isRequired,
  recFormat: PropTypes.string.isRequired,
}

export default Topbar;

